import { Promise as Promise$1 } from 'rsvp';
import '@ember/runloop';
import '@ember/application';
import '@ember/service';
import { stop, animate } from '../animate.js';
import '@ember/array';
import '@ember/object/internals';
import '../constraints.js';
import '../mutation-observer.js';
import '../velocity-ext.js';

// BEGIN-SNIPPET cross-fade-definition
function crossFade(opts = {}) {
  stop(this.oldElement);
  return Promise$1.all([animate(this.oldElement, {
    opacity: 0
  }, opts), animate(this.newElement, {
    opacity: [opts.maxOpacity || 1, 0]
  }, opts)]);
}
// END-SNIPPET

export { crossFade as default };
//# sourceMappingURL=cross-fade.js.map
